import { zodResolver } from '@hookform/resolvers/zod';
import { useForm } from 'react-hook-form';
import { z } from 'zod';

import { Form, FormControl, FormField, FormItem, FormLabel, FormMessage } from '../../../components/ui/form';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '../../../components/ui/select';
import './Form.style.css';
import type { Step4 } from '@edwin-group/cj-graphql/generated/graphql';

const FormSchema = z.object({
  role: z.string({
    required_error: 'Please select a role.',
  }),
});

interface SelectFormStep4Props {
  response: Step4;
  onClickProfile: (profile: string) => void;
  defaultValues?: object;
}

export function SelectForm({ response, onClickProfile, defaultValues }: SelectFormStep4Props) {
  const form = useForm<z.infer<typeof FormSchema>>({
    resolver: zodResolver(FormSchema),
    defaultValues,
  });

  return (
    <Form {...form}>
      <form className="w-full space-y-6 md:w-2/4">
        <FormField
          control={form.control}
          name="role"
          render={({ field }) => (
            <FormItem>
              <FormLabel>
                <p className="text-sh-xxs">{response?.role?.label}</p>
              </FormLabel>
              <Select
                onValueChange={(role) => {
                  onClickProfile(role);
                }}
                defaultValue={field.value}>
                <FormControl>
                  <SelectTrigger>
                    <SelectValue placeholder="Select a role" />
                  </SelectTrigger>
                </FormControl>
                <SelectContent>
                  {response?.roles?.map((role) => {
                    return (
                      <SelectItem key={role!.role!} value={role!.role!}>
                        {role!.role!}
                      </SelectItem>
                    );
                  })}
                </SelectContent>
              </Select>
              <FormMessage />
            </FormItem>
          )}
        />
      </form>
    </Form>
  );
}
